import './ProductStarRating.scss';

import { number, string } from 'prop-types';
import React, { memo } from 'react';

import ReviewStarRating from '../ReviewPage/ReviewStarRating';

const ProductStarRating = ({ averageReviewRate, totalReviewCount, productDetailUrl }) => {
  const handleOpenProductDetailPage = () => {
    if (productDetailUrl) {
      window.location.href = productDetailUrl;
    }
  };

  return averageReviewRate && totalReviewCount ? (
    <div className='product-star-rating' onClick={handleOpenProductDetailPage}>
      <ReviewStarRating disableRating defaultRate={averageReviewRate} />
      <ul className='product-star-rating__detail'>
        <li className='product-star-rating__detail__count-number'>
          <span>&#40;{totalReviewCount}&#41;</span>
        </li>
      </ul>
    </div>
  ) : (
    <></>
  );
};

ProductStarRating.propTypes = {
  averageReviewRate: number,
  totalReviewCount: number,
  productDetailUrl: string
};

export default memo(ProductStarRating);
